import axios from 'axios';
import router from '../router/index'
import { Message, Loading } from "element-ui";
let that = this
const options = {
    lock: true,
    text: '加载中，请稍后',//加载动画的文字
    spinner: 'el-icon-loading',//加载动画的图标
    background: 'rgba(0, 0, 0, 0)'//加载动画的背景
}
const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    timeout: 5000,
});
let loadingInstance = '';
service.interceptors.request.use(
    config => {
        loadingInstance = Loading.service(options);
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(

    response => {

        loadingInstance.close();
        if (response.status === 200) {
            if (response.data.code === 200) {
                window.localStorage.setItem('token', response.data.token)
                return response.data;
            } else {
                Message({
                    message: `错误码:${response.data.code} 错误信息:${response.data.data}`,
                    type: 'error'
                })
                if (response.data.code == 41004) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('companyInfo')
                    localStorage.removeItem('userinfo')
                    router.push('/')
                }
                return response.data;
            }
        } else {
            Promise.reject();
        }
    },
    error => {
        let loadingInstance = Loading.service(options);
        loadingInstance.close();
        return Promise.reject();
    }
);

export default service;
